const PERCENT_PATTERN = /^\d+(\.\d+)?$/;
const RUPEE_PATTERN = /^\d+(\.\d{1,2})?$/;

function readRawNumber(raw) {
  if (raw == null || raw === "") return "";
  if (typeof raw === "object") {
    const decimal =
      raw.$numberDecimal ?? raw.$numberDouble ?? raw.$numberInt ?? raw.$numberLong;
    if (decimal != null && decimal !== "") return String(decimal).trim();
    return "";
  }
  return String(raw).trim();
}

/** Display string for a stored number. Blank when the value is missing. */
export function formatStoredNumber(raw) {
  const text = readRawNumber(raw);
  if (text === "") return "";
  const n = Number(text);
  if (!Number.isFinite(n)) return "";
  return String(n);
}

/** Number from 0 through 100, or null when blank or out of range. */
export function parsePercent0to100(raw) {
  const text = String(raw ?? "").trim();
  if (!PERCENT_PATTERN.test(text)) return null;
  const n = Number(text);
  if (!Number.isFinite(n) || n < 0 || n > 100) return null;
  return n;
}

/** Rupee amount of 0 or more, up to 2 decimal places, or null. */
export function parseNonNegativeRupee(raw) {
  const text = String(raw ?? "").trim();
  if (!RUPEE_PATTERN.test(text)) return null;
  const n = Number(text);
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
}

export const EMPTY_CLUB_TABLE_FEES = {
  tableMdrPercent: "",
  tableGstPercent: "",
};

export function pickClubTableFees(club) {
  if (!club || typeof club !== "object") return { ...EMPTY_CLUB_TABLE_FEES };
  return {
    tableMdrPercent: formatStoredNumber(
      club.tableMdrPercent ?? club.table_mdr_percent
    ),
    tableGstPercent: formatStoredNumber(
      club.tableGstPercent ?? club.table_gst_percent
    ),
  };
}

export function validateClubTableFees(values, message) {
  const errors = {};
  if (parsePercent0to100(values?.tableMdrPercent) == null) {
    errors.tableMdrPercent = message;
  }
  if (parsePercent0to100(values?.tableGstPercent) == null) {
    errors.tableGstPercent = message;
  }
  return errors;
}

export function clubTableFeePutFields(values) {
  return {
    tableMdrPercent: parsePercent0to100(values?.tableMdrPercent),
    tableGstPercent: parsePercent0to100(values?.tableGstPercent),
  };
}

/** Finite fee from an event record, or null when it was not stored. */
export function pickTableBookingFixedFee(event) {
  if (!event || typeof event !== "object") return null;
  const display = formatStoredNumber(
    event.tableBookingFixedFee ?? event.table_booking_fixed_fee
  );
  if (display === "") return null;
  return parseNonNegativeRupee(display);
}
